import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const LinkedAccountRow = ({ data, showActions, onTreeviewClick, onWhsClick }) => (
  <tr key={ data.accountId }>
    <td align="center">
      <Link
        to={ `/account/${ data.accountId }` }
        id={ `${ data.accountId }-id` }
      >
        { data.accountNumber }
      </Link>
    </td>
    <td align="center">
      <Link
        to={ `/account/${ data.accountId }` }
        id={ `${ data.accountId }-name` }
      >
        { data.accountName }
      </Link>
    </td>
    <td align="center">
      <Link
        to={ `/customer/${ data.customerId }` }
        id={ `${ data.customerId }-id` }
      >
        { data.customerIdentifier }
      </Link>
    </td>
    <td align="center">
      <Link
        to={ `/customer/${ data.customerId }` }
        id={ `${ data.customerId }-name` }
      >
        { data.customerName }
      </Link>
    </td>
    { showActions && <td align="center">
      <div className="form-action-btn-group">
        <button
          className="btn btn-sm"
          type="button"
          title="Show IMY Tree"
          onClick={ () => onTreeviewClick && onTreeviewClick(data.accountId) }
        >
          <span className="icon icon-treeview" />
        </button>
        <button
          className="btn btn-sm icon-whd-stmt"
          type="button"
          title="View Digital Withholding Statement"
          onClick={ () => onWhsClick && onWhsClick(data.accountId) }
        >
          WHS
        </button>
      </div>
    </td> }
  </tr>
);

LinkedAccountRow.propTypes = {
  data: PropTypes.shape({
    accountId: PropTypes.number,
    accountNumber: PropTypes.string,
    accountName: PropTypes.string,
    customerId: PropTypes.number,
    customerIdentifier: PropTypes.string,
    customerName: PropTypes.string
  }).isRequired,
  showActions: PropTypes.bool,
  onTreeviewClick: PropTypes.func,
  onWhsClick: PropTypes.func
};

LinkedAccountRow.defaultProps = {
  showActions: false,
  onTreeviewClick: null,
  onWhsClick: null
};

export default LinkedAccountRow;
